import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/auth'

export default {
  login(email, password, client) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/login`, {
      email,
      password,
      codCliERP: client,
    })
  },
  refreshToken() {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/refresh`)
  },
  me() {
    return axios.post(config.webApiBase + RESOURCE_NAME + '/me')
  },
  /*
  recoverPassword (email) {
    return axios.post(config.webApiBase + RESOURCE_NAME + '/password/email', {
      email
    });
  },
 */
}
